"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomProperty = /** @class */ (function () {
    function CustomProperty() {
    }
    return CustomProperty;
}());
exports.default = CustomProperty;
//# sourceMappingURL=CustomProperty.js.map